import { createSelector } from 'reselect';

import getTable from './getTable';
import { getDisableTableNumberSaleBody } from './config';

export interface IDineInSaleBodyContentHttpDto {
  PickupTime: string;
  TableNumber?: string;
}

export default createSelector(
  [getTable, getDisableTableNumberSaleBody],
  (table, disableTableNumberSaleBody): IDineInSaleBodyContentHttpDto => ({
    ...(disableTableNumberSaleBody === false
      ? { TableNumber: String(table) }
      : {}),
    PickupTime: 'ASAP',
  }),
);
